import { defaultMarketResearchState } from "@relode/core";
import produce from "immer";

import names, {
    ClientMarketResearchActionTypes,
} from "./clientMarketResearchActionTypes";
import { ClientMarketResearchState } from "./clientMarketResearchState";

export const clientMarketResearchReducer = (
    state: ClientMarketResearchState,
    action: ClientMarketResearchActionTypes
) =>
    produce(state, draft => {
        switch (action.type) {
            case names.MARKET_RESEARCH_UPDATE_CRITERIA: {
                const criteriaIsEmpty =
                    action.payload.data && // 👈 null and undefined check
                    Object.keys(action.payload.data).length === 0 && // empty object
                    Object.getPrototypeOf(action.payload.data) ===
                        Object.prototype;

                draft.searchMode = "configure";
                draft.searchCriteria = criteriaIsEmpty
                    ? undefined
                    : action.payload.data;
                draft.searchResults = defaultMarketResearchState;
                break;
            }

            case names.MARKET_RESEARCH_LOAD: {
                draft.searchMode = "search";
                draft.searchCriteria = action.payload.data;
                break;
            }

            case names.MARKET_RESEARCH_LOAD_SUCCESS: {
                break;
            }

            case names.MARKET_RESEARCH_LOAD_FAILURE: {
                break;
            }

            case names.MARKET_RESEARCH_COMPENSATION: {
                draft.searchResults.compensation = {
                    isBusy: true,
                };
                break;
            }

            case names.MARKET_RESEARCH_COMPENSATION_SUCCESS: {
                draft.searchResults.compensation = {
                    isBusy: false,
                    error: undefined,
                    data: action.payload.data,
                };
                break;
            }

            case names.MARKET_RESEARCH_COMPENSATION_FAILURE: {
                draft.searchResults.compensation = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUPPLY_DEMAND: {
                draft.searchResults.supplyDemand = {
                    isBusy: true,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUPPLY_DEMAND_SUCCESS: {
                draft.searchResults.supplyDemand = {
                    isBusy: false,
                    data: action.payload.data,
                    error: undefined,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUPPLY_DEMAND_FAILURE: {
                draft.searchResults.supplyDemand = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            case names.MARKET_RESEARCH_DIVERSITY: {
                draft.searchResults.diversity = {
                    isBusy: true,
                };
                break;
            }

            case names.MARKET_RESEARCH_DIVERSITY_SUCCESS: {
                draft.searchResults.diversity = {
                    isBusy: false,
                    data: action.payload.data,
                };
                break;
            }

            case names.MARKET_RESEARCH_DIVERSITY_FAILURE: {
                draft.searchResults.diversity = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            case names.MARKET_RESEARCH_SHARE: {
                draft.searchResults.share = {
                    isBusy: true,
                };
                break;
            }

            case names.MARKET_RESEARCH_SHARE_SUCCESS: {
                draft.searchResults.share = {
                    isBusy: false,
                    data: action.payload.data,
                };
                break;
            }

            case names.MARKET_RESEARCH_SHARE_FAILURE: {
                draft.searchResults.share = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUMMARY: {
                draft.searchResults.summary = {
                    isBusy: true,
                    data: undefined,
                    error: undefined,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUMMARY_SUCCESS: {
                draft.searchResults.summary = {
                    isBusy: false,
                    data: action.payload.data,
                    error: undefined,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUMMARY_FAILURE: {
                draft.searchResults.summary = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            case names.MARKET_RESEARCH_JOB_MANAGER: {
                draft.jobManager = {
                    isBusy: true,
                    data: undefined,
                    error: undefined,
                };
                break;
            }

            case names.MARKET_RESEARCH_JOB_MANAGER_SUCCESS: {
                draft.jobManager = {
                    isBusy: false,
                    data: action.payload.data,
                    error: undefined,
                };
                break;
            }

            case names.MARKET_RESEARCH_JOB_MANAGER_FAILURE: {
                draft.jobManager = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }
        }
    });
